<script lang="ts">
	import PercentageChange from 'components/PercentageChange/PercentageChange.svelte';
	import TableRow from 'components/Table/TableRow/TableRow.svelte';
	import type { ITableData } from '../types';
	import TableCell from 'components/Table/TableCell/TableCell.svelte';
	import formatNumber from 'utils/formatNumber';

	export let data: ITableData;
	export let dark: boolean;

	const { rank, address, wallet, balanceBtc, balanceUsd, coinAmount, weekChange } = data;
</script>

<TableRow {dark} tableRowRef={null} class="coin-holders-table-row">
	<TableCell {dark} class="holder-rank">
		{rank}
	</TableCell>
	<TableCell {dark} class="holder-address">
		{address}
	</TableCell>
	<TableCell {dark} class="holder-wallet">
		<span class:noWallet={!wallet} class:withWallet={wallet}>{wallet || '--'}</span>
	</TableCell>
	<TableCell {dark} class="holder-balance-btc">
		{formatNumber(Number(balanceBtc), null, Number(balanceBtc) > 99999999, 'decimal')}
	</TableCell>
	<TableCell {dark} class="holder-balance-usd">
		{formatNumber(Number(balanceUsd), 'USD', Number(balanceUsd) > 99999999)}
	</TableCell>
	<TableCell {dark} class="holder-coins-percentage">
		{Number(coinAmount)}%
	</TableCell>
	<TableCell {dark} class="holder-posses-change">
		{#if Number(weekChange) !== 0}
			<PercentageChange {dark} dayChange={Number(weekChange)} />
		{:else}
			{'--'}
		{/if}
	</TableCell>
</TableRow>

<style lang="scss">
	@import 'coinHoldersTableRow';
</style>
